export interface ISkillState {
    "skill_id": number,
    "skill_name": string,
    "potential_score": number,
    "current_score": number
}

export enum IEmployeeSkillActionTypes {
    FETCH_EMPLOYEE_SKILLS_REQUEST = 'FETCH_EMPLOYEE_SKILLS_REQUEST',
    FETCH_EMPLOYEE_SKILLS_SUCCESS = 'FETCH_EMPLOYEE_SKILLS_SUCCESS',
    FETCH_EMPLOYEE_SKILLS_FAILURE = 'FETCH_EMPLOYEE_SKILLS_FAILURE',
}



export type IEmployeeSkillsActionCreator = {
    type?: string;
    payload?: ISkillState[];
};
